import { useEffect } from 'react';
import { useSmartNotifications } from '@/hooks/useSmartNotifications';
import { useAuth } from '@/hooks/useAuth';

/**
 * Smart Notifications Provider
 * This component initializes the smart notifications system for authenticated users.
 * It sets up real-time subscriptions for signals, trades, and price alerts.
 */
export function SmartNotificationsProvider() {
  const { user } = useAuth();
  
  // Initialize smart notifications hook - this sets up all realtime subscriptions
  useSmartNotifications();

  // Log when notifications are initialized
  useEffect(() => {
    if (user) {
      console.log('Smart notifications initialized for user:', user.id);
    }
  }, [user]);

  // This component doesn't render anything - it just initializes subscriptions
  return null;
}
